<button
  [class]="!isSubmitButtonClicked ? defaultSubmitButtonClass : submitButtonClass"
  (click)="!isSubmitButtonClicked ? submit() : ''"
  [disabled]="isSubmitButtonClicked"
>
  <div class="tenor-gif-embed" data-postid="12514414" data-share-method="host" data-aspect-ratio="1" data-width="100%"></div>
  @if (showConfetti()) {
  <img src="/assets/gif/confetti-2.gif" alt="" class="w-[100%] absolute left-0" />
  }

  <div [class]="isSubmitButtonClicked ? 'flex items-center justify-center h-[25px] w-full' : 'flex items-center justify-between h-[25px] w-full'">
    <div
      class="font-bold w-full text-center"
      [style.min-width]="isDiscoveryContent ? 'fit-content' : 'fit-content'"
      [ngClass]="{ 'text-black': isSubmitButtonClicked, 'text-white': !isSubmitButtonClicked, 'text-[12px]': !!customTextSize }"
    >
      {{ isSubmitButtonClicked ? 'complete' : 'Mark as complete' }}
    </div>
  </div>
</button>
